import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const selectThemeToken: any = {
  inputBorderRadius: 4,
  //============================ BORDER ==================================/
  activeBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  hoverBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  boxShadowSecondary: variableEffects["BoxShadowElevation3"],
  activeOutlineColor: "transparent",
  colorErrorOutline: "transparent",

  //============================ ICON ==================================/
  colorIcon: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorIconHover: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  fontSizeIcon: variableTypography["BodyMediumFontSize"],

  //========================= FONT =================================/
  inputFontSize: variableTypography["BodyMediumFontSize"],
  inputFontSizeLG: variableTypography["BodyLargeFontSize"],
  inputFontSizeSM: variableTypography["BodyMediumFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
  lineHeightLG: variableTypography["BodyMediumLineHeight"],
  fontFamily: variableTypography["BodyMediumFontFamily"],

  //========================= COLOR =================================/
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextPlaceholder: variableColors["ColorFigmaNeutralGrayscaleGray70"],

  //========================= DISABLED =================================/
  colorBgContainerDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],

  //========================= SIZE =================================/
  controlHeight: 40,
  controlHeightLG: 48,
  controlHeightSM: 36,
  paddingBlock: 8,
  paddingBlockLG: 12,
  paddingBlockSM: 6,
  paddingInline: 8,
  paddingInlineLG: 8,
  paddingInlineSM: 6,

  //========================= OPTION =================================/
  optionFontSize: variableTypography["BodyLargeFontSize"],
  optionHeight: 32,
  optionLineHeight: variableTypography["BodyLargeLineHeight"],
  optionPadding: "6px 8px 6px 16px",
  optionActiveBg: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  optionSelectedBg: "transparent",
  optionSelectedColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  borderRadiusLG: 0,
  borderRadiusSM: 0,
  borderRadiusXS: 0,
  paddingSM: 10,
  paddingXS: 8,
  paddingXXS: 0,

  //========================= OPTION GROUP =================================/
  // Tokens for ant-select-item-group styling
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  fontSizeSM: variableTypography["BodyLargeFontSize"],
  lineHeightSM: variableTypography["BodyLargeLineHeight"],
};
